import './src/styles/global.css';
import ReactDOM from 'react-dom';
import { pushEventToDataLayer } from './src/utils/analytics';

export function replaceHydrateFunction() {
    return (element, container, callback) => {
        ReactDOM.render(element, container, callback);
    };
}

export const onRouteUpdate = ({ location }) => {
  pushEventToDataLayer('pageview', { page: location.pathname + location.search });
};
